import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-main-layout',
  template: `
    <app-header />
    <div class="main-layout__content">
      <router-outlet />
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }

      .main-layout__content {
        max-width: 1240px;
        padding: 0 var(--medium);
        margin: 72px auto 80px;
      }

      @media (max-width: 450px) {
        .main-layout__content {
          margin-top: 120px;
        }
      }
    `
  ],
  imports: [HeaderComponent, RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainLayoutComponent {}

